export default __webpack_public_path__ + "static/media/ready-to-test.47d2f021.png";